import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  cancel1xim2hrvjmwpn as cancel,
  Key_instancepi2bbb0csu5f as Key_instance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { SupervisorJobythnfxkr3jxc as SupervisorJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Supervisor.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPlugin16sdkdabbewya as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return LOGGER;
}
var LOGGER;
function get_HttpRequestLifecycle() {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  return HttpRequestLifecycle;
}
var HttpRequestLifecycle;
function PipelineContext$proceed$ref(p0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* p0.proceed_tynop7_k$($completion);
    return Unit_instance;
  }), 0, 9, 219, VOID, [p0]);
}
function SetupRequestContext$install$slambda($handler) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    yield* $($handler($this$intercept.context_1, PipelineContext$proceed$ref($this$intercept), $completion), $completion);
    return Unit_instance;
  }), 2);
}
var SetupRequestContextClass;
function SetupRequestContext() {
  if (SetupRequestContextClass === VOID) {
    class $ {
      install_u8vcoy_k$(client, handler) {
        var tmp = Phases_getInstance().Before_1;
        client.requestPipeline_1.intercept_k21bv3_k$(tmp, SetupRequestContext$install$slambda(handler));
      }
      install_qsy0pg_k$(client, handler) {
        return this.install_u8vcoy_k$(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SetupRequestContext');
    SetupRequestContextClass = $;
  }
  return SetupRequestContextClass;
}
var SetupRequestContext_instance;
function SetupRequestContext_getInstance() {
  return SetupRequestContext_instance;
}
function attachToClientEngineJob(requestJob, clientEngineJob) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var handler = clientEngineJob.invokeOnCompletion_n6cffu_k$((cause) => {
    if (!(cause == null)) {
      get_LOGGER().trace_fti9bv_k$('Cancelling request because engine Job failed with error: ' + cause.toString());
      cancel(requestJob, 'Engine failed', cause);
    } else {
      get_LOGGER().trace_fti9bv_k$('Cancelling request because engine Job completed');
      requestJob.complete_9ww6vb_k$();
    }
    return Unit_instance;
  });
  requestJob.invokeOnCompletion_n6cffu_k$((it) => {
    handler.dispose_3nnxhr_k$();
    return Unit_instance;
  });
}
function HttpRequestLifecycle$lambda($this$createClientPlugin) {
  _init_properties_HttpRequestLifecycle_kt__jgkmfx();
  var tmp = SetupRequestContext_instance;
  $this$createClientPlugin.on_z1oiz_k$(tmp, HttpRequestLifecycle$lambda$slambda($this$createClientPlugin));
  return Unit_instance;
}
function HttpRequestLifecycle$lambda$slambda($this_createClientPlugin) {
  return constructCallableReference((request, proceed, $completion) => orPromise($completion, function *($completion) {
    var executionContext = SupervisorJob(request.executionContext_1);
    attachToClientEngineJob(executionContext, ensureNotNull($this_createClientPlugin.client_1.coroutineContext_1.get_y2st91_k$(Key_instance)));
    var tmp;
    try {
      request.executionContext_1 = executionContext;
      tmp = yield* $(proceed($completion), $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        executionContext.completeExceptionally_xyzekf_k$(cause);
        throw cause;
      } else {
        throw $p;
      }
    }
    finally {
      executionContext.complete_9ww6vb_k$();
    }
    return Unit_instance;
  }), 2);
}
var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
  if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
    properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
    HttpRequestLifecycle = createClientPlugin('RequestLifecycle', HttpRequestLifecycle$lambda);
  }
}
//region block: init
SetupRequestContext_instance = new (SetupRequestContext())();
//endregion
//region block: exports
export {
  get_HttpRequestLifecycle as get_HttpRequestLifecycle1e7j0z243lnj5,
};
//endregion

//# sourceMappingURL=HttpRequestLifecycle.mjs.map
